import { IDHFControlDefinition, IDHFSection, IDHFSectionOptions } from "./common/businesslogic/index";
import { IBaseControlOptions } from "./common/UI/Controls/BaseControl";
import { app, IReference } from "./globals";
import { ml } from "./common/matrixlib";
import { SelectSearchQueue } from "./SelectSearchQueue";
import { BaseDHFSection } from "./client/plugins/DocumentSections/BaseDHFSection";

export type {
    ISingleSelectOptions,
    IDoubleSelectOptions,
    ISingleDefaultControllerConfig,
    IDoubleDefaultControllerConfig,
};
export { SingleSelectBase };

interface ISingleSelectOptions extends IDHFSectionOptions {
    search?: string;
}
interface IDoubleSelectOptions extends IDHFSectionOptions {
    searchFrom?: string;
    searchTo?: string;
}

interface ISingleDefaultControllerConfig {
    default: ISingleSelectOptions;
}
interface IDoubleDefaultControllerConfig {
    default: ISingleSelectOptions;
}

abstract class SingleSelectBase<T extends ISingleSelectOptions> extends BaseDHFSection<T> implements IDHFSection {
    abstract renderControl(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions): void;

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    addSignatures(signatures: string[], currentValue: IDHFControlDefinition) {}
    abstract showSpecificSettings(
        ctrl: IDHFControlDefinition,
        ctrlParameter: IBaseControlOptions,
        custom: JQuery,
    ): void;

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected addSpecificSettings(controllerConfig: ISingleSelectOptions, custom: JQuery) {
        let search = $(
            '<input autocomplete="off" style="height: 20px;width: 420px;float: right;" class="form-control p_search" type="text" name="search" value="" /> ',
        );
        let sp = $("<div>Find items by search: </div>").append(search);
        custom.append(sp);
        search.val(controllerConfig.search ? controllerConfig.search : "");
    }

    abstract saveSpecificSettingsAsync(
        ctrl: IDHFControlDefinition,
        ctrlParameter: IBaseControlOptions,
        custom: JQuery,
    ): Promise<boolean>;

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected setSpecificSettings(controllerConfig: ISingleSelectOptions, custom: JQuery) {
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        let changed = controllerConfig.search != $(custom.find(".p_search")[0]).val();
        controllerConfig.search = $(custom.find(".p_search")[0]).val();

        return changed;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    hasSearch(ctrl: IDHFControlDefinition) {
        let controllerConfig = this.getConfig(ctrl);
        return !!controllerConfig.search;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    executeSearch(ctrl: IDHFControlDefinition) {
        let controllerConfig = this.getConfig(ctrl);

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        app.searchAsyncMinimalOutput(controllerConfig.search, null, true).done(function (itemIds) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (itemIds.length != 0) {
                $(".refreshNeeded", ctrl.control).removeClass("refreshNeeded");
                $(".contentNeeded", ctrl.control).removeClass("contentNeeded");
            }
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            ctrl.control.getController().setValue(itemIds);
        });
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async verifySearchAsync(ctrl: IDHFControlDefinition) {
        let controllerConfig = this.getConfig(ctrl);

        if (controllerConfig.search) {
            $(".fa-sync-alt", ctrl.control).addClass("icon-refresh-animate");
            SelectSearchQueue.addToSearchQueue(() => {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                return app.searchAsyncMinimalOutput(controllerConfig.search, null, true).done(async function (current) {
                    $(".fa-sync-alt", ctrl.control).removeClass("icon-refresh-animate");
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    let lastVal = await ctrl.control.getController().getValueAsync();
                    let last: IReference[] = <IReference[]>lastVal ? JSON.parse(lastVal) : [];
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    if (current.length == 0) {
                        return;
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                    } else if (last.length != current.length) {
                        return;
                    } else {
                        let lastItems = last
                            .map(function (lastItem) {
                                return lastItem.to;
                            })
                            .sort(function (a, b) {
                                return ml.Item.sort(a, b);
                            });
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        let currentItems = current.sort(function (a, b) {
                            return ml.Item.sort(a, b);
                        });
                        for (let idx = 0; idx < lastItems.length; idx++) {
                            // TODO: MATRIX-7555: lint errors should be fixed for next line
                            // eslint-disable-next-line
                            if (lastItems[idx] != currentItems[idx]) {
                                return;
                            }
                        }
                    }
                    $(".refreshNeeded", ctrl.control).removeClass("refreshNeeded");
                });
            });
        }
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async verifyContentAsync(ctrl: IDHFControlDefinition) {
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        let lastVal = await ctrl.control.getController().getValueAsync();
        let last: IReference[] = <IReference[]>lastVal ? JSON.parse(lastVal) : [];
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (last.length == 0) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            ctrl.control.closest(".ft_dhf").find(".baseControlHelp").addClass("contentNeeded");
        } else {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            ctrl.control.closest(".ft_dhf").find(".baseControlHelp").removeClass("contentNeeded");
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected removeSpaces(str: string) {
        if (!str) {
            return "";
        }
        return str
            .split("|")
            .map(function (strp) {
                return strp.trim();
            })
            .join("|")
            .split(",")
            .map(function (strp) {
                return strp.trim();
            })
            .join(",");
    }
}
